<template>
    <div class="back-button-wrapper">
        <div v-if="fromName === 'Boxes'">
            <button @click="$router.push(fromPath)" class="primary icon">
                <span class="icon far fa-chevron-left"></span>Back to Boxes
            </button>
        </div>
        <div v-else-if="fromName === 'FormLibrary'">
            <button @click="$router.push(fromPath)" class="primary icon">
                <span class="icon far fa-chevron-left"></span>Back to Form Library
            </button>
        </div>
        <div v-else-if="fromPath.startsWith('/admin')">
            <button @click="$router.push(fromPath)" class="primary icon">
                <span class="icon far fa-chevron-left"></span>Back to Administration
            </button>
        </div>
        <div v-else>
            <button @click="$router.push('/boxes')" class="primary icon">
                <span class="icon far fa-chevron-left"></span>Go to Boxes
            </button>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'OfficeBackButton',
        computed: {
            fromRoute() {
                return this.$store.getters['base/fromRoute'];
            },
            fromName() {
                return this.fromRoute?.name;
            },
            fromPath() {
                return this.fromRoute?.path || '/boxes';
            },
        },
    };
</script>
<style lang="scss" scoped>
    .back-button-wrapper {
        display: flex;
        align-items: center;
    }
</style>
